export default __webpack_public_path__ + "static/09_嘉宾头像_李盛-3f1b37f17876fb346e05c57dabeee70f.png";